<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="lgrm-emoji-rating">
      <Emoji
        :rating="index + 1"
        v-for="(option, index) in options"
        :label="option.label"
        :key="option.id"
        :color="color"
        :selected="selected === option.id"
        :borderColor="borderColor"
        :organColor="organColor"
        @click="select(option.id)"
        :class="{'lgrm-first': index===0, 'lgrm-last': index === options.length - 1}"
        :disableToolTip="disableToolTip"
        ref='emojis'
      ></Emoji>
  </div>
</template>


<script>
import Emoji from './Emoji'
export default {
  name: 'EmojiRating',
  components: { Emoji },
  props: {
    options: {
      type: Array,
      default: function() {
        return [
          { id: 1, label: 'Very   Satisfied' },
          { id: 2, label: 'Somewhat Satisfied' },
          { id: 3, label: 'Neither satisfied nor dissatisfied' },
          { id: 4, label: 'Somewhat Dissatisfied' },
          { id: 5, label: 'Very Dissatisfied' }
        ]
      }
    },
    selectedValue: {
      type: Number,
      default: -1
    },
    color: { type: String, default: '#132968' },
    borderColor: { type: String},
    organColor: { type: String},
    readonly: {
      type: Boolean,
      default: false
    },
    disableToolTip: {
      type: Boolean,
      default: true
    },
    animationEnabled: {
      type: Boolean,
      default: true
    }
  },
  mounted(){
    console.log(this.$refs.emojis.map((d) => d.$el))
    if(this.animationEnabled)
      this.$anime({
        targets: this.$refs.emojis.map((d) => d.$el),
        direction: 'alternate',
        loop: false,
        easing: 'spring(1, 80, 10, 0)',
        delay: this.$anime.stagger(100),
        keyframes: [
          {translateY: -10},
          {translateY: 5},
          {translateY: 0},
        ],
      });

  },
  data: function() {
    return {
      selected: this.selectedValue,
      vertical: false
    }
  },
  computed: {
    updatedQuestion: function() {
      if (this.brandName)
        return this.question.replace('{brand_name}', this.brandName)
      return this.question
    },
    ranges: function() {
      let ranges = range(this.minValue, this.maxValue + 1)
      if (this.vertical) {
        ranges.reverse()
      }
      return ranges
    },
    animationStyle: function() {
      if(this.animationEnabled) {
            return {
              transform: "translateY(20px)"
            }
          }
          
    }
  },
  methods: {
    select(value) {
      if (this.readonly) return
      this.selected = value
      this.$emit('change', value)
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="stylus" scoped>
.lgrm-choice-options {
    display: inline-block
    text-align left
    font-size 16px
    .lgrm-choice-option {
        margin-bottom 10px
    }
}

.lgrm-emoji {
    // transform: translateY(20px)
}

.lgrm-vertical {
    .lgrm-emoji {
        width 40px
        left: 0px
        // opacity 0
    }
}
</style>

<style lang="stylus">
.lgrm-emoji-rating:hover {
    .lgrm-emoji .lgrm-emoji-label {
     display: none !important
   }
   
}

</style>